module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1e_R.9455afd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-1e_R.svg
// module id = 513
// module chunks = 0